export default __webpack_public_path__ + "static/media/topBanner.993ce606.jpg";